import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { Fab } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { t } from 'utils/i18n';
import styles from './AddButton.module.css';

const AddButton = (props) => {
  const { className, ...other } = props;

  return (
    <Fab className={cn(styles.fab, className)} {...other}>
      <AddIcon />
    </Fab>
  );
};

AddButton.propTypes = {
  color: Type.oneOfType([
    Type.oneOf(['inherit', 'primary', 'secondary']),
    Type.string,
  ]),
  className: Type.string,
  'aria-label': Type.string,
};

AddButton.defaultProps = {
  'aria-label': t('add'),
  color: 'primary',
  className: undefined,
};

export default AddButton;
